import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useCookie } from "react-recipes";
import { Button, Snackbar, Typography } from "@material-ui/core";

import { appRoutes } from "routes";
import localStorage from "utils/localStorage";

import useStyles from "./useStyles";

const CookieBanner = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [cookieBanner] = useCookie("cookie_banner%3Ahidden", false);

  const handleClose = () => {
    localStorage.setItem("cookie_banner:hidden", true);
    setOpen(false);
  };

  if (localStorage.hasItem("cookie_banner:hidden")) {
    return null;
  }
  if (cookieBanner) {
    localStorage.setItem("cookie_banner:hidden", true);
    return null;
  }

  return (
    <Snackbar
      open={open}
      className={classes.root}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      message={
        <>
          <Typography component="p" className={classes.message}>
            We use cookies to personalize and improve your experience. By continuing to use our website, you agree to
            our{" "}
            <NavLink target="_blank" to={appRoutes.privacyPath()} className={classes.link}>
              Cookie Policy
            </NavLink>
          </Typography>
          <Button variant="contained" color="secondary" size="small" className={classes.button} onClick={handleClose}>
            Ok
          </Button>
        </>
      }
    />
  );
};

export default CookieBanner;
